import { db } from "../config/firebase";
import {
  QuerySnapshot,
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { api } from "../config/api";

const isPermissionDenied = (error) => {
  const code = error?.code || "";
  const msg = String(error?.message || "");
  return (
    code === "permission-denied" ||
    msg.toLowerCase().includes("insufficient permissions")
  );
};

// Get All Users
export const getUsers = async () => {
  const ref = collection(db, "users");
  const q = query(ref, where("role", "==", "user"));

  try {
    const res = await getDocs(q);

    if (res.empty) {
      throw new Error("No users found with the specified role");
    }

    const fetchUsers = res.docs.map((e) => {
      return {
        ...e.data(),
        id: e.id,
      };
    });

    return fetchUsers;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

// New function to get all admin types
export const getAllAdminUsers = async () => {
  const ref = collection(db, "users");
  const q = query(ref, where("role", "in", ["admin", "super admin", "managing admin", "lead admin", "editor"]));

  try {
    const res = await getDocs(q);

    if (res.empty) {
      throw new Error("No admin users found");
    }

    const adminUsers = res.docs.map((e) => {
      return {
        ...e.data(),
        id: e.id,
      };
    });

    return adminUsers;
  } catch (error) {
    if (isPermissionDenied(error)) {
      try {
        const proxyRes = await api.get(
          "/firestore/admin-users?roles=admin,super admin,managing admin,lead admin,editor"
        );
        return Array.isArray(proxyRes.data) ? proxyRes.data : [];
      } catch (proxyError) {
        console.error("Error fetching admin users via proxy:", proxyError);
        const status = proxyError?.response?.status;
        if (status === 401 || status === 403) return [];
        throw proxyError;
      }
    }

    console.error("Error fetching admin users:", error);
    throw error;
  }
};

export const getAllSuperAdminUsers = async () => {
  const ref = collection(db, "users");
  const q = query(ref, where("role", "in", ["admin", "super admin"]));

  try {
    const res = await getDocs(q);

    if (res.empty) {
      throw new Error("No admin users found");
    }

    const adminUsers = res.docs.map((e) => {
      return {
        ...e.data(),
        id: e.id,
      };
    });

    return adminUsers;
  } catch (error) {
    if (isPermissionDenied(error)) {
      try {
        const proxyRes = await api.get("/firestore/admin-users?roles=admin,super admin");
        return Array.isArray(proxyRes.data) ? proxyRes.data : [];
      } catch (proxyError) {
        console.error("Error fetching admin users via proxy:", proxyError);
        const status = proxyError?.response?.status;
        if (status === 401 || status === 403) return [];
        throw proxyError;
      }
    }

    console.error("Error fetching admin users:", error);
    throw error;
  }
};

// Keep the original getAdmins function for backward compatibility
export const getAdmins = async () => {
  const ref = collection(db, "users");
  const q = query(ref, where("role", "in", ["admin", "managing admin", "lead admin", "editor"]));

  try {
    const res = await getDocs(q);

    if (res.empty) {
      throw new Error("No users found with the specified role");
    }

    const fetchUsers = res.docs.map((e) => {
      return {
        ...e.data(),
        id: e.id,
      };
    });

    return fetchUsers;
  } catch (error) {
    if (isPermissionDenied(error)) {
      try {
        const proxyRes = await api.get(
          "/firestore/admin-users?roles=admin,managing admin,lead admin,editor"
        );
        return Array.isArray(proxyRes.data) ? proxyRes.data : [];
      } catch (proxyError) {
        console.error("Error fetching users via proxy:", proxyError);
        const status = proxyError?.response?.status;
        if (status === 401 || status === 403) return [];
        throw proxyError;
      }
    }

    console.error("Error fetching users:", error);
    throw error;
  }
};

export const getUser = async (id) => {
  const ref = doc(db, "users", id);

  try {
    const res = await getDoc(ref);

    if (!res.exists()) {
      throw new Error("User not found");
    }

    return { ...res.data(), id };
  } catch (error) {
    console.error("Error fetching User:", error);
    throw error;
  }
};
